import { Injectable } from '@angular/core';
import { SYSTEM } from 'src/assets/config/config';
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private http: HttpClient) { }

  sendEmail(from: string, displayName: string, subject: string, body: string): Promise<any> {
    const email = {
      from: from,
      displayName: displayName,
      to: SYSTEM.main_email,
      subject: subject,
      body: body
    };

    return this.http
      .post(`${SYSTEM.base_service_url}Service.svc/SendEmail`, email)
      .toPromise();
  }
}
